import { render } from "./PreExamView.vue?vue&type=template&id=02f8b74f"
import script from "./PreExamView.vue?vue&type=script&lang=js"
export * from "./PreExamView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__